/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Members_Deactivate_DescriptionInputs */



/**
* | output |
* | --- |
* | "{email} will be signed out and any chat in progress will stop. Their spaces, data and connected integrations are preserved, and you can reactivate them at an..." |
*
* @param {Members_Deactivate_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_deactivate_description = /** @type {((inputs: Members_Deactivate_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Deactivate_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.email} wird abgemeldet und laufende Chats werden gestoppt. Spaces, Daten und verbundene Integrationen bleiben erhalten, und Sie können das Mitglied jederzeit reaktivieren. Der Platz wird freigegeben.`)
	return /** @type {LocalizedString} */ (`${i?.email} will be signed out and any chat in progress will stop. Their spaces, data and connected integrations are preserved, and you can reactivate them at any time. They stop occupying a seat.`)
});